import { z } from 'zod';

/** Versioned domain profiles supported by the Case Wiki shared surface. */
export const CaseWikiDomainProfileIdSchema = z.enum([
  'common_v1',
  'penal_v1',
  'public_v1',
]);
export type CaseWikiDomainProfileId = z.infer<typeof CaseWikiDomainProfileIdSchema>;

const PUBLIC_LAW_PROCEDURE_TYPE_LABELS = new Set([
  'droit public',
  'droit administratif',
  'contentieux administratif',
]);

function normalizeLegalDomainLabel(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, ' ');
}

/**
 * Matches the administrative procedure labels persisted across current and legacy cases.
 *
 * The Case Wiki profile router and legalworkspace vocabulary must use the same
 * case/accent/whitespace-insensitive vocabulary so a legacy administrative case
 * cannot silently fall back to the generic domain profile.
 */
export function isPublicLawProcedureType(value: string | null | undefined): boolean {
  return value !== null && value !== undefined
    && PUBLIC_LAW_PROCEDURE_TYPE_LABELS.has(normalizeLegalDomainLabel(value));
}

/** Server-owned labels and feature switches exposed to Case Wiki consumers. */
export const CaseWikiSurfaceCapabilitiesSchema = z.object({
  profile_id: CaseWikiDomainProfileIdSchema,
  supports: z.object({
    procedure_rail: z.boolean(),
    procedural_review: z.boolean(),
  }).strict(),
  labels: z.object({
    procedure_rail: z.string().min(2).max(80),
    procedural_review: z.string().min(2).max(80),
  }).strict(),
}).strict();
export type CaseWikiSurfaceCapabilities = z.infer<
  typeof CaseWikiSurfaceCapabilitiesSchema
>;
